<template>
  <main class="container solution-airsterile">
    <section ref="sectionRef" class="wellcome-section">
      <button class="btn outline">Air Sterilizer</button>
      <h1>
        Comprehensive <br class="mo_show" />Lineup for
        <br />
        Preemptive Virus Attack
      </h1>
      <p>
        With each change of season, CESCO's air sterilizer proactively sterilizes pathogens that cause flu and various respiratory diseases before
        they can affect people.
      </p>

      <router-link to="/contact/mail/send?local=eng">
        <p ref="buttonRef" id="applyButton" :class="[buttonClass, buttonHiddenClass]">Send Email</p>
      </router-link>
    </section>

    <img
      :src="require(`@/assets/images/solution/airsterile/main${mobileCheck ? '_mo' : ''}.png`)"
      class="main-img"
      alt="CESCO [Solution] Air Sterilizer"
    />

    <section class="section airsterile-comprehensive">
      <div class="contents-center">
        <div class="crucial-reason">
          <h3 class="title-section">Air Sterilizers are <br class="mo_show" />crucial for…</h3>

          <div class="card-type-i">
            <div class="card">
              <img src="@/assets/images/solution/airsterile/card_i_01.svg" />
              <div>
                <p>Families with toddler who are concerned about flu every time the season changes</p>
              </div>
            </div>
            <div class="card">
              <img src="@/assets/images/solution/airsterile/card_i_02.svg" />
              <div>
                <p>Individuals concerned about pneumonia or who frequently cough</p>
              </div>
            </div>
            <div class="card">
              <img src="@/assets/images/solution/airsterile/card_i_03.svg" />
              <div>
                <p>Elderly with compromised immune systems worried about complications</p>
              </div>
            </div>
            <div class="card">
              <img src="@/assets/images/solution/airsterile/card_i_04.svg" />
              <div>
                <p>Daycares prone to rapid disease transmission</p>
              </div>
            </div>
          </div>
        </div>

        <div class="why-air-sterilizer">
          <h3 class="title-section">Why CESCO Air Sterilizer</h3>

          <div class="layout-i">
            <div class="layout-i-content">
              <h4>Why is an air sterilizer necessary in everyday life?</h4>
              <p>
                Annually, it rigorously tests <br class="mo_show" />
                and verifies its sterilization capabilities against the influenza (H1N1) virus and airborne bacteria such as pneumococcus and
                Staphylococcus aureus.
              </p>
            </div>
            <div class="layout-i-content">
              <img :src="require(`@/assets/images/solution/airsterile/layout_i_01.png`)" class="main-img" alt="CESCO [Solution] Air Sterilizer" />
            </div>
            <div class="layout-i-content">
              <img :src="require(`@/assets/images/solution/airsterile/layout_i_02.png`)" class="main-img" alt="CESCO [Solution] Air Sterilizer" />
            </div>
            <div class="layout-i-content">
              <h4>Why does the CESCO air sterilizer activate a preemptive virus attack system?</h4>
              <p>
                Suppressing viruses before they attack is crucial. Our smart care technology detects human movement, and an advanced UV sterilization
                tunnel eliminates 99.99% of airborne viruses, ensuring the air remains clean.
              </p>
            </div>
          </div>
        </div>

        <div class="special-features">
          <h3 class="title-section">Special Features</h3>
          <p class="description-section">CESCO Air Sterilizer, Developed with Advanced CESCO Science</p>

          <div class="bg-img-card-i-1">
            <h4>UV Sterilization Tunnel</h4>
            <p>
              The 'sterilization tunnel,' through which forcibly inhaled air passes, features UV-C sterilization lamps that physically destroy virus
              DNA. This module is uniquely designed by CESCO with an S-shaped flow and mirror walls to prolong the air's retention.
            </p>
            <img src="@/assets/images/solution/airsterile/special_features_img.png" alt="CESCO [Solution] Air Sterilizer" />
          </div>

          <div class="bg-img-card-i-2">
            <h4>Powerful UV-C sterilization lamp that eliminates 99.99% of airborne viruses</h4>

            <div class="lamp-container">
              <div class="lamp-box">
                <div class="lamp-circle">
                  <div>
                    <p>UV-C</p>
                    <span> LAMP </span>
                  </div>
                </div>
                <div class="lamp-textbox">
                  <h5>
                    UV-C Sterilization <br class="pc_show" />
                    Lamp
                  </h5>
                  <p>A lamp that uses UV-C light to completely destroy the genetic material of viruses.</p>
                </div>
              </div>
              <div class="lamp-box">
                <div class="lamp-circle">
                  <div>
                    <p>S</p>
                    <span> CURVE </span>
                  </div>
                </div>
                <div class="lamp-textbox">
                  <h5>
                    S-Type Flow <br class="pc_show" />
                    Design
                  </h5>
                  <p>
                    An S-shaped flow structure allows air to circulate through the sterilization tunnel for an extended duration, enhancing
                    sterilization effectiveness.
                  </p>
                </div>
              </div>
              <div class="lamp-box">
                <div class="lamp-circle">
                  <div>
                    <p>M</p>
                    <span> MIRROR WALL </span>
                  </div>
                </div>
                <div class="lamp-textbox">
                  <h5>
                    Mirror Wall <br class="pc_show" />
                    Design
                  </h5>
                  <p>The design includes a mirror wall that leverages reflective effects to maximize sterilization power.</p>
                </div>
              </div>
              <div class="lamp-box">
                <div class="lamp-circle">
                  <div>
                    <p>LED</p>
                    <span> UV-C LED </span>
                  </div>
                </div>
                <div class="lamp-textbox">
                  <h5>
                    UV-C LED <br />
                    Sterilization Lamp
                  </h5>
                  <p>A compact, powerful UV-C LED sterilization lamp designed to destroy viruses efficiently and continuously.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section tab-area">
      <div class="contents-center">
        <div class="tab-info">
          <h3 class="title-section center">
            CESCO Air Sterilizer <br class="mo_show" />
            Full Lineup
          </h3>

          <div class="tabs">
            <button
              v-for="item in tabList"
              :key="`tab-${item.id}`"
              :id="`tab-${item.id}`"
              :class="['tab-button', tab === item.id && 'active']"
              @click="handleTabClick(item.id)"
            >
              {{ item.name }}
            </button>
          </div>
          <button class="btn-list">Press the button to check.</button>
        </div>
      </div>

      <div v-if="!mobileCheck" class="tab-contents">
        <div v-if="tab === 0" class="tab-content" id="tab1">
          <swiper
            :slides-per-view="'auto'"
            :centered-slides="true"
            :loop="true"
            :autoplay="{
              delay: 2000,
              disableOnInteraction: false
            }"
            :modules="[Autoplay]"
            class="air-sterilizer-swiper"
          >
            <swiper-slide>
              <div>
                <p class="black">
                  CESCO air sterilizer Sense Me<br />
                  preemptively attacks<br />
                  airborne viruses
                </p>
                <img src="@/assets/images/solution/airsterile/tab01_01.png" alt="CESCO [Solution] Air Sterilizer" />
              </div>
            </swiper-slide>
            <swiper-slide>
              <div>
                <p>
                  Begins smart care mode for managing safe spaces with<br />
                  a keen sense of interior design
                </p>
                <img src="@/assets/images/solution/airsterile/tab01_02.png" alt="CESCO [Solution] Air Sterilizer" />
              </div>
            </swiper-slide>
            <swiper-slide>
              <div>
                <p>
                  Motion-sensing technology for<br />
                  preemptive virus attack
                  <span>
                    Uses human motion detection sensors to activate
                    <br />the airborne virus preemptive attack system.
                  </span>
                </p>
                <img src="@/assets/images/solution/airsterile/tab01_03.png" alt="CESCO [Solution] Air Sterilizer" />
              </div>
            </swiper-slide>
            <swiper-slide>
              <div>
                <p>
                  Compact design compatible with<br />
                  any interior
                  <span>
                    Available in four color options and<br />
                    offers mounting choices (wall type/stand type)<br />
                    to match the space and aesthetic preferences.
                  </span>
                </p>
                <img src="@/assets/images/solution/airsterile/tab01_04.png" alt="CESCO [Solution] Air Sterilizer" />
              </div>
            </swiper-slide>
          </swiper>
        </div>

        <div v-if="tab === 1" class="tab-content" id="tab2">
          <swiper
            :slides-per-view="'auto'"
            :centered-slides="true"
            :loop="true"
            :autoplay="{
              delay: 2000,
              disableOnInteraction: false
            }"
            :modules="[Autoplay]"
            class="air-sterilizer-swiper"
          >
            <swiper-slide>
              <div>
                <p>
                  CESCO Air Sterilizer Max Power<br />
                  rapidly sterilizes even large<br />
                  spaces with two sterilization<br />
                  tunnels
                </p>
                <img src="@/assets/images/solution/airsterile/tab02_01.png" alt="CESCO [Solution] Air Sterilizer" />
              </div>
            </swiper-slide>
            <swiper-slide>
              <div>
                <p>
                  Equipped with two upper and
                  <br />
                  lower UV sterilization tunnels,
                  <br />
                  effectively sterilizing
                  <br />
                  even large areas
                </p>
                <img src="@/assets/images/solution/airsterile/tab02_02.png" alt="CESCO [Solution] Air Sterilizer" />
              </div>
            </swiper-slide>
            <swiper-slide>
              <div>
                <p>
                  Technology that powerfully sterilizes<br />
                  even large spaces
                  <span>
                    Operates the airborne virus preemptive attack system with<br />
                    two UV sterilization tunnels in large indoor spaces<br />
                    frequented by many people.
                  </span>
                </p>
                <img src="@/assets/images/solution/airsterile/tab02_03.png" alt="CESCO [Solution] Air Sterilizer" />
              </div>
            </swiper-slide>
            <swiper-slide>
              <div>
                <p>
                  Sensing air contamination to
                  <br />
                  initiate a preemptive attack
                  <span>
                    An increase in CO2 levels triggers<br />
                    an infection risk alarm, enabling the system<br />
                    to switch to turbo mode for<br />
                    rapid air sterilization.
                  </span>
                </p>
                <img src="@/assets/images/solution/airsterile/tab02_04.png" alt="CESCO [Solution] Air Sterilizer" />
              </div>
            </swiper-slide>
          </swiper>
        </div>

        <div v-if="tab === 2" class="tab-content" id="tab3">
          <swiper
            :slides-per-view="'auto'"
            :centered-slides="true"
            :loop="true"
            :autoplay="{
              delay: 2000,
              disableOnInteraction: false
            }"
            :modules="[Autoplay]"
            class="air-sterilizer-swiper"
          >
            <swiper-slide>
              <div>
                <p>
                  CESCO air sterilizer can be installed<br />

                  anywhere tocreate a safe space
                </p>
                <img src="@/assets/images/solution/airsterile/tab03_01.png" alt="CESCO [Solution] Air Sterilizer" />
              </div>
            </swiper-slide>
            <swiper-slide>
              <div>
                <p>
                  Flexible installation options suit the environment, <br />
                  effectively sterilizing indoor spaces where<br />
                  ventilation is challenging
                </p>
                <img src="@/assets/images/solution/airsterile/tab03_02.png" alt="CESCO [Solution] Air Sterilizer" />
              </div>
            </swiper-slide>
            <swiper-slide>
              <div>
                <p>
                  Freely installable in various spaces
                  <span>
                    Tailors a 24-hour airborne virus preemptive attack system to<br />
                    environments concerned about viral threats.
                  </span>
                </p>
                <img src="@/assets/images/solution/airsterile/tab03_03.png" alt="CESCO [Solution] Air Sterilizer" />
              </div>
            </swiper-slide>
            <swiper-slide>
              <div>
                <p>
                  Proven air sterilization<br />
                  technology for<br />
                  creating safe spaces
                  <span>
                    As CESCO's inaugural air sterilizer,<br />
                    it is widely used in various workplaces<br />
                    and homes, with flexible mounting options<br />
                    (wall type/stand type).
                  </span>
                </p>
                <img src="@/assets/images/solution/airsterile/tab03_04.png" alt="CESCO [Solution] Air Sterilizer" />
              </div>
            </swiper-slide>
          </swiper>
        </div>

        <div v-if="tab === 3" class="tab-content" id="tab4">
          <swiper
            :slides-per-view="'auto'"
            :centered-slides="true"
            :loop="true"
            :autoplay="{
              delay: 2000,
              disableOnInteraction: false
            }"
            :modules="[Autoplay]"
            class="air-sterilizer-swiper"
          >
            <swiper-slide>
              <div>
                <p>
                  Equipped with both<br />
                  a fine dust cleaning engine and<br />
                  a preemptive virus attack engine
                </p>
                <img src="@/assets/images/solution/airsterile/tab04_01.png" alt="CESCO [Solution] Air Sterilizer" />
              </div>
            </swiper-slide>
            <swiper-slide>
              <div>
                <p>
                  Removes 99.99% of fine dust and<br />
                  kills 99.98% of viruses!
                </p>
                <img src="@/assets/images/solution/airsterile/tab04_02.png" alt="CESCO [Solution] Air Sterilizer" />
              </div>
            </swiper-slide>
            <swiper-slide>
              <div>
                <p>
                  Simultaneous air purification and virus sterilization
                  <span>
                    For those requiring an air purifier and desiring an air sterilizer,
                    <br />
                    his unit includes two engines.
                  </span>
                </p>
                <img src="@/assets/images/solution/airsterile/tab04_03.png" alt="CESCO [Solution] Air Sterilizer" />
              </div>
            </swiper-slide>
            <swiper-slide>
              <div>
                <p>
                  Operation adapted to different situations
                  <span>
                    Operates the air purifier on days with<br />
                    significant fine dust and<br />
                    activates the virus preemptive attack system<br />
                    when viral concerns arise.
                  </span>
                </p>
                <img src="@/assets/images/solution/airsterile/tab04_04.png" alt="CESCO [Solution] Air Sterilizer" />
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </section>

    <section class="section regular-maintenance">
      <div class="contents-center">
        <div class="regular-maintenance-info">
          <h3 class="title-section">
            Professional &
            <br />
            Regular Maintenance
          </h3>

          <h4>Full lineup of CESCO air sterilizers with CareShip Service</h4>

          <p class="description-section">
            Managed systematically by professionals
            <br />
            who have completed CESCO’s specialized training.
            <br />
            <span> *CareShip service varies by product. </span>
          </p>
        </div>
        <div class="regular-maintenance-causes">
          <div class="cause-item">
            <img src="@/assets/images/icons/banner_cesco_dualcare_ico01 1.svg" />
            <div>
              <h4 class="title">
                Regular Maintenance of
                <br class="pc_show" />
                Filters
              </h4>
              <p class="label">Replacement of pre-filters, custom filters, deodorizing filters, HEPA filters, and carbon cover filters</p>
            </div>
          </div>
          <div class="cause-item">
            <img src="@/assets/images/icons/banner_cesco_dualcare_ico01 2.svg" />
            <div>
              <h4 class="title">UV-C Sterilization Lamp Replacement</h4>
              <p class="label">Regular lamp maintenance ensures effective virus and bacteria elimination.</p>
            </div>
          </div>
          <div class="cause-item">
            <img src="@/assets/images/icons/banner_cesco_dualcare_ico01 3.svg" />
            <div>
              <h4 class="title">Air Sterilizer Device Management</h4>
              <p class="label">Manages sensor operation and controls airflow, lighting, and mode settings</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section ref="checkSectionRef" class="sub-footer">
      <h2>
        CESCO air Sterilizer for preemptive virus <br class="pc_show" />
        attack, personalized to create safe spaces <br class="pc_show" />
        for various situations.
      </h2>
      <p>Explore products rigorously tested for their ability to sterilize viruses and bacteria.</p>

      <router-link to="/contact/mail/send?local=eng" class="btn"> Send Email </router-link>
    </section>
  </main>

  <ModalView v-if="mobileCheck" :modal-state="modalState" @close-modal="closeModal">
    <AirSterileModalContent :tab="tab" :text="tabList[tab].name" />
  </ModalView>
</template>

<script setup>
import { inject } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay } from 'swiper/modules'
import { useMeta } from 'vue-meta'
import { useScroll, useModal, useTab } from '@/hooks'
import ModalView from '@/components/common/ModalView.vue'
import AirSterileModalContent from '@/components/modal/AirSterileModalContent.vue'

const { sectionRef, checkSectionRef, buttonRef, buttonClass, buttonHiddenClass } = useScroll()
const { modalState, openModal, closeModal } = useModal()
const { tab, handleTabClick } = useTab(openModal)

const mobileCheck = inject('mobileCheck')

const tabList = [
  { id: 0, name: 'Air Sterilizer Sense me' },
  { id: 1, name: 'Air Sterilizer Max Power' },
  { id: 2, name: 'Air Sterilizer UV Power' },
  { id: 3, name: 'Air Sterilizing Purifier Dual Care' }
]

useMeta({
  title: 'CESCO - Air Sterilizer',
  meta: [
    {
      vmid: 'description',
      name: 'description',
      content: 'Comprehensive Lineup for Preemptive Virus Attack'
    }
  ]
})
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/airsterile.scss';
</style>
